var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Watch } from "vue-property-decorator";
import { TurnRecordService } from "~/services/domain-service/turn-record.service";
import { PageService } from "~/utils/page.service";
import { namespace } from "vuex-class";
var CollectionExecutionModule = namespace("collection-execution");
var CirculationHistory = /** @class */ (function (_super) {
    __extends(CirculationHistory, _super);
    function CirculationHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            caseTurnTime: [],
            triggerAction: "",
            operatorRealName: ""
        };
        _this.selected = {};
        _this.dataSet = [];
        return _this;
    }
    CirculationHistory.prototype.onCaseNumberChange = function (val) {
        if (!val)
            return;
        this.refreshData();
    };
    CirculationHistory.prototype.refreshData = function () {
        var _this = this;
        this.turnRecordService
            .findTurnRecordDetailPage(this.caseNo, this.model, this.pageService)
            .subscribe(function (data) { return (_this.dataSet = data); });
    };
    CirculationHistory.prototype.activated = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(PageService)
    ], CirculationHistory.prototype, "pageService", void 0);
    __decorate([
        Dependencies(TurnRecordService)
    ], CirculationHistory.prototype, "turnRecordService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CirculationHistory.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CirculationHistory.prototype, "caseNo", void 0);
    __decorate([
        Watch("caseNo", { immediate: true })
    ], CirculationHistory.prototype, "onCaseNumberChange", null);
    CirculationHistory = __decorate([
        Component({
            components: {}
        })
    ], CirculationHistory);
    return CirculationHistory;
}(Vue));
export default CirculationHistory;
